import _ from "lodash";
import React, { useState, useLayoutEffect } from "react";
import { useI18n } from "Hooks";

import { Tabs } from "@toddle-edu/ds-web";

import { PARENT, STAFF, STUDENT } from "Constants/stringConstants";
import { isIdEqual } from "Utils";
import { isMessagingRevempEnabled } from "MessagingV2/modules/Utils";

import classes from "./ViewMembers.scss";
import UserTypeList from "../UserTypeList";

const getInitialUserTypeTab = ({ usersByType }) => {
  return _.first(_.keys(usersByType));
};

const tabContainerStyles = { paddingBlock: "12px" };

const TAB_USER_TYPE_ORDER = [STAFF, STUDENT, PARENT];

const userTypeLabels = {
  [STUDENT]: "common:student",
  [PARENT]: "common:family_member",
  [STAFF]: "common:staff_member",
};

const userTypeLabelsPlural = {
  [STUDENT]: "common:student_plural",
  [PARENT]: "common:family_member_plural",
  [STAFF]: "common:staff_members_plural",
};

const getUserTypeLabels = ({ totalUsersCount, userType, t }) =>
  totalUsersCount === 1
    ? t(userTypeLabels[userType])
    : t(userTypeLabelsPlural[userType]);

const getUserTypeList = ({ users }) => {
  const usersByType = _.groupBy(users, "type");

  const userTypeList = _.reduce(
    TAB_USER_TYPE_ORDER,
    (acc, userType) => {
      if (usersByType[userType]) {
        acc[userType] = usersByType[userType];
      }
      return acc;
    },
    {}
  );

  return userTypeList;
};

const getUserTypeTabs = ({ t, usersByType }) => {
  return _.map(_.keys(usersByType), userType => {
    const totalUsersCount = _.size(usersByType[userType]);

    return {
      label: `${getUserTypeLabels({
        totalUsersCount,
        t,
        userType,
      })} (${totalUsersCount})`,
      value: userType,
    };
  });
};

const ViewMembers = props => {
  const {
    users,
    handleRemoveUser,
    updateUsers,
    threadsContainerStyles,
    isAddMembers,
    isMemberUpdate = true,
  } = props;

  const usersByType = getUserTypeList({ users });
  const isUIRevempEnabled = isMessagingRevempEnabled();

  const { t } = useI18n(["common"]);

  const [currentUserType, setCurrentUserType] = useState(
    getInitialUserTypeTab({ usersByType })
  );

  useLayoutEffect(() => {
    if (_.isEmpty(usersByType[currentUserType])) {
      setCurrentUserType(getInitialUserTypeTab({ usersByType }));
    }
  }, [usersByType, currentUserType]);

  const handleTabChange = value => {
    setCurrentUserType(value);
  };

  const onRemoveClick = async ({ user }) => {
    if (isAddMembers) {
      const updatedUser = _.filter(users, u => {
        return !isIdEqual(user.id, u.id);
      });

      updateUsers(updatedUser);
    } else {
      handleRemoveUser({ user });
    }
  };

  return (
    <div className={classes.viewMembersContainer}>
      <div className={classes.tabContainer}>
        <Tabs
          options={getUserTypeTabs({ t, usersByType })}
          onChange={handleTabChange}
          value={currentUserType}
          containerStyle={tabContainerStyles}
          hasSeparator={true}
        />
      </div>
      <div
        className={
          isUIRevempEnabled
            ? classes.threadsContainerWrapperV2
            : classes.threadsContainerWrapper
        }
        style={threadsContainerStyles}
      >
        <UserTypeList
          users={usersByType[currentUserType]}
          onRemoveClick={onRemoveClick}
          isMemberUpdate={isMemberUpdate}
        />
      </div>
    </div>
  );
};

export default ViewMembers;
